<template>
  <vue-pdf-app :pdf="url"></vue-pdf-app>
</template>

<script>
import VuePdfApp from 'vue-pdf-app'
import 'vue-pdf-app/dist/icons/main.css'

export default {
  components: {
    VuePdfApp
  },
  data () {
    return {
      url: 'https://ds2.modnpay.kr/ce62c588-d4e3-4d61-b038-5b0b6900e9ec'
    }
  }
}
</script>
